import { CSSProperties } from "react";
import classes from "./ShareButton.module.css";
import { ShareOutlineIcon } from "@/components/Icons";
import { useAppDispatch } from "@/store/hooks";
import { setGlobalPopupElement } from "@/store/features/globalSlice";
import ShareModal from "@/components/ShareModal";

interface Props {
  className?: string;
  style?: CSSProperties;

  shareUrl: string;
  description?: string;
  hashtag?: string[];
  size?: "sm" | "lg";
  image?: string;
}

const ShareButton = ({
  className,
  style,

  shareUrl,
  description,
  hashtag,

  size = "lg",
  image,
}: Props) => {
  const classNames = [classes.ShareButton, className];

  const dispatch = useAppDispatch();

  const sizePx = size === "lg" ? "22px" : "18px";

  const handleShareClick = () => {
    dispatch(
      setGlobalPopupElement(
        <ShareModal
          shareUrl={shareUrl}
          description={description}
          hashtag={hashtag}
          image={image}
          onClose={() => dispatch(setGlobalPopupElement(null))}
        />
      )
    );
  };

  return (
    <button
      onClick={handleShareClick}
      className={classNames.join(" ")}
      style={style}
    >
      <ShareOutlineIcon
        className={classes.icon}
        width={sizePx}
        height={sizePx}
      />
      <p className={classes.text + (size === "sm" ? " !text-xs" : "")}>Share</p>
    </button>
  );
};

export default ShareButton;
